import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { ApiService } from '../services/api.service';
import { IUserManual } from '../models/user-manual.model';
import { NavigationService } from '../services/navigation.service';


export const userManualResolver: ResolveFn<IUserManual[]> = () => {
  const apiService = inject(ApiService);
    const navigationService = inject(NavigationService)

  return apiService.fetchUserManualContent().pipe(
    catchError((error) => {
      navigationService.handleResolverError(error)
      return EMPTY;
    })
  );
};
